import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { useStyles } from "./styles";

const BasicButton = ({
  title,
  variant = "contained",
  onClick,
  disabled = false,
  sx,
  type = "button",
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.btn}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      sx={sx}
      type={type}
      {...rest}
    >
      {title}
    </Button>
  );
};

BasicButton.propTypes = {
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  color: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  type: PropTypes.string,
};

export default BasicButton;
